import { Box, Card, Grid, makeStyles, Typography } from "@material-ui/core";
import { t2 } from "../Locale";
import toto from "../assets/image/toto.png";
import { useDispatch, useSelector } from "react-redux";

import Global from "../assets/css/style";
import Timer2 from "../components/Timer2";
import TotoDrawNo from "../components/TotoDrawNo";
import DeleteIcon from "@material-ui/icons/Delete";
import { setPlaceBetFinal2 } from "../redux/items/TotoPlaceBetFinal";

const useStyles = makeStyles((theme) => ({
  card: {
    height: "100%",
    width: "100%",
    position: "absolute",
    backgroundImage: `url(${
      process.env.REACT_APP_YES_APP === undefined
        ? toto
        : process.env.REACT_APP_ASSETS3 + "toto.png?d=xxxxxxx"
    })`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    opacity: 1,
    zIndex: -1,
  },
}));

const CardToto = ({ canDelete = false }) => {
  const classes = useStyles();
  const language = useSelector((state) => state.Language);
  const dispatch = useDispatch();
  const totoPlaceBetFinal = useSelector((state) => state.totoPlaceBetFinal);
  const totoSet = useSelector((state) => state.drawSet.TotoSet);

  return totoPlaceBetFinal.map((a, aI) => (
    <Card
      style={{
        position: "relative",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.45)",
        borderRadius: 21,
        border: "0.5px solid #C4C4C4",
        marginTop: 16,
        zIndex: 0,
      }}
      key={aI}
    >
      <Box className={classes.card} />
      <Grid container direction="column" style={{ padding: 16 }}>
        <Grid item container style={{ padding: 12 }}>
          <Grid item container>
            <Typography
              variant="h5"
              style={{
                fontSize: 18,
                fontWeight: "bold",
                width: "100%",
              }}
            >
              {t2(a.betType, language)}
            </Typography>
            <Typography
              style={{
                fontSize: 16,
                fontWeight: "thin",
                marginBottom: 10,
              }}
              variant="subtitle2"
            >
              {a.placeBet.length} {t2("Board", language)}
            </Typography>
          </Grid>
          <Grid item container>
            <Grid item xs={9}>
              <Typography>
                <b>{t2("Draw Date", language)}:</b>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography>
                <b>{t2("Draw No.", language)} </b>
              </Typography>
            </Grid>
          </Grid>
          <Grid item container>
            <Grid item xs={9}>
              <Timer2 selectedDrawParam={a.drawWeeks} />
            </Grid>
            <Grid item xs={3}>
              <TotoDrawNo selectedDrawParam={a.drawWeeks} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Card
            style={{
              backgroundColor: "#F7F7F7",
              position: "relative",
              borderRadius: 16,
              marginTop: 10,
            }}
          >
            {a.placeBet.map((b, bI) => {
              return (
                <div
                  key={bI}
                  style={{
                    borderBottom: "1px solid #ddd",
                    textAlign: "center",
                  }}
                >
                  {b.eachPlaceBet.map((c, cI) => (
                    <Typography
                      key={cI}
                      style={{
                        color: Global.color,
                        padding: 10,
                        fontWeight: "bold",

                        paddingTop: 18,
                        display: "inline-block",
                        textAlign: "center",
                        width: 30,
                        marginLeft: 1,
                        fontSize: 20,
                      }}
                    >
                      {c}
                    </Typography>
                  ))}
                </div>
              );
            })}
          </Card>
        </Grid>

        <Grid item container style={{ marginTop: 0 }}>
          <Grid
            item
            container
            xs={6}
            style={{
              alignItems: "center",
              position: "relative",
              zIndex: 1,
            }}
          >
            {canDelete && (
              <span
                style={{
                  cursor: "pointer",
                  color: "red",
                }}
                onClick={() => {
                  let d = [...totoPlaceBetFinal];
                  d.splice(aI, 1);
                  dispatch(setPlaceBetFinal2([...d]));
                }}
              >
                <DeleteIcon
                  style={{
                    fontSize: 32,
                    color: Global.defaultColor,
                  }}
                />
              </span>
            )}
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3} style={{ paddingTop: 10 }}>
            <Typography>{t2("Sub Total", language)}</Typography>
            <Typography variant="h6" style={{ fontWeight: "bold" }}>
              $
              {(() => {
                let totoSet2 = {};
                totoSet.forEach((a) => {
                  totoSet2[a.name] = a.price;
                });

                let multi = 1;
                if (a.drawWeeks === "2 Draws") multi = 2;
                else if (a.drawWeeks === "4 Draws") multi = 4;

                return (
                  totoSet2[a.betType] *
                  a.placeBet.length *
                  multi
                ).toFixed(2);
              })()}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  ));
};

export default CardToto;
